import { render, staticRenderFns } from "./ControlPartPositions.vue?vue&type=template&id=2a90c3ef&scoped=true"
import script from "./ControlPartPositions.vue?vue&type=script&lang=js"
export * from "./ControlPartPositions.vue?vue&type=script&lang=js"
import style0 from "./ControlPartPositions.vue?vue&type=style&index=0&id=2a90c3ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a90c3ef",
  null
  
)

export default component.exports